import { render, staticRenderFns } from "./metrics_pagination.vue?vue&type=template&id=0ff0e4d2&scoped=true&"
import script from "./metrics_pagination.vue?vue&type=script&lang=js&"
export * from "./metrics_pagination.vue?vue&type=script&lang=js&"
import style0 from "./metrics_pagination.vue?vue&type=style&index=0&id=0ff0e4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0e4d2",
  null
  
)

export default component.exports